import { DateTime } from "luxon";

type Translate = (key: string, options: Record<string, string | number>) => string;

type SavedAtParams = {
	createdAt: DateTime;
	/** "Now" in the same zone, passed in so the label is a pure function of its inputs. */
	now: DateTime;
	/** The department's time zone: "today" is the department's today, wherever the viewer is. */
	timezone: string;
	/** The UI language, so month names and the clock read as the rest of the app does. */
	locale: string;
	t: Translate;
};

/**
 * When a version was saved, short and in the department's time zone: "Today, 3:14 PM", "Yesterday, 9:02 AM",
 * "Oct 2, 3:14 PM" — with the year once it isn't this year's.
 */
export const versionSavedAtLabel = ({ createdAt, now, timezone, locale, t }: SavedAtParams): string => {
	const saved = createdAt.setZone(timezone).setLocale(locale);
	const today = now.setZone(timezone).startOf("day");
	const time = saved.toLocaleString(DateTime.TIME_SIMPLE);
	if (saved.hasSame(today, "day")) return t("printout.custom.ai.version.date.today", { time });
	if (saved.hasSame(today.minus({ days: 1 }), "day")) return t("printout.custom.ai.version.date.yesterday", { time });
	return t("printout.custom.ai.version.date.other", {
		date: saved.toLocaleString(saved.hasSame(today, "year") ? { month: "short", day: "numeric" } : DateTime.DATE_MED),
		time,
	});
};
